import { Button } from 'components/Button';
import { Tab } from 'components/Tab';
import { TabNav } from 'components/TabNav';
import { useAlert } from 'hooks/useAlert';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { BaseRoutes } from 'routes/BaseRoutes';
import { menuListItems } from '../../../assets/menu/menuList';
import { Menu } from '../../../components/Menu';
import { LeadsTableNew } from './LeadsTableNew';
import { LeadsTableDisapproved } from './LeadsTableDisapproved';

import { Container, WrapperButton } from './styles';


const tabs = ['Novos Cadastros', 'Reprovados'];

interface LeadDetailsContextProps {
  hasChangedFields: boolean,
  setHasChangedFields: React.Dispatch<React.SetStateAction<boolean>>
}

const DEFAULT_VALUE:LeadDetailsContextProps = {
  hasChangedFields: false,
  setHasChangedFields: () => {}
}

const LeadDetailsContext = React.createContext<LeadDetailsContextProps>(DEFAULT_VALUE);

export const SellersLeads: React.FC = () => {
  const {push} = useHistory();
  const [hasChangedFields, setHasChangedFields] = useState(DEFAULT_VALUE.hasChangedFields);
  const [selected, setSelected] = useState(tabs[0]);
  const [targetSelected, setTagetSelected] = useState<string>(tabs[0]);
  const { alert, setTextAlertInterface, openAlert, closeAlert, caller } = useAlert();

  const handleTabSelected = (event: React.MouseEvent, tab: string) => {
    if (hasChangedFields) {
      setTagetSelected(tab);
      setTextAlertInterface({
        positionCenter: true,
        title: 'Campos atualizados',
        description: 'Alguns campos foram atualizados e as informações serão perdidas. Deseja continuar ou voltar e salvar suas alterações?',
        closeAlertText: 'Voltar',
        continueAlertText: 'Continuar'
      });
      openAlert(true, 'leadDetails');
    } else {
      setSelected(tab)
    }
  }

  useEffect(() => {
    if (caller == 'leadDetails') {
      if (alert.typeContinue === "save") {
        setSelected(targetSelected);
        setHasChangedFields(false);
        closeAlert();
        return;
      }
      if (alert.typeContinue === "discard"){
        closeAlert();
        return;
      }
    }
  }, [alert])

  return (
    <Menu links={menuListItems}>
      <TabNav tabs={tabs} selected={selected} onTabSelected={handleTabSelected} backPath={BaseRoutes.sellers}>

        <Tab isSelected={selected} tabName="Novos Cadastros">
          <LeadDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <Container>
              <WrapperButton>
                <Button
                  label="Cadastrar novo varejista"
                  typeBtn="blue"
                  size="medium"
                  onClick={() => push(BaseRoutes.sellersLeadCreate)}
                />
              </WrapperButton>
              <LeadsTableNew/>
            </Container>
          </LeadDetailsContext.Provider>
        </Tab>

        <Tab isSelected={selected} tabName="Reprovados">
          <LeadDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <Container>
              <LeadsTableDisapproved/>
            </Container>
          </LeadDetailsContext.Provider>
        </Tab>
        
      </TabNav>
    </Menu>
  );
}